'use client'

import { Builder, withChildren } from '@builder.io/react'

import { IconNames, IconText } from './IconText'

Builder.registerComponent(withChildren(IconText), {
  name: 'IconText',
  noWrap: true,
  inputs: [
    {
      name: 'iconName',
      type: 'text',
      enum: IconNames as any,
      defaultValue: IconNames[0],
    },
    {
      name: 'iconColor',
      type: 'color',
      defaultValue: '#000',
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Text',
        options: {
          text: 'Content',
          defaultStyles: {
            color: '#000',
          },
        },
      },
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/icons.svg',
})
